module.exports = __webpack_public_path__ + "static/media/PCA_white.ba03995a.svg";